export default function Footer() {
  return (
    <footer>
      <div className="footer-top">
        <div>
          <div className="footer-logo">
            <svg width="28" height="12" viewBox="0 0 36 16" fill="none">
              <polyline
                points="0,16 6,2 12,10 18,0 24,10 30,2 36,16"
                stroke="#c9a96e"
                strokeWidth="1.5"
                fill="none"
                strokeLinejoin="round"
              />
              <line
                x1="0"
                y1="16"
                x2="36"
                y2="16"
                stroke="#c9a96e"
                strokeWidth="1.5"
              />
            </svg>
            <div className="footer-brand-name">
              ARCH <span>&amp;</span> CROWN
            </div>
          </div>

          <div className="footer-tagline">
            Where Every Moment Crowns Itself
          </div>

          <p className="footer-about">
            Founded with love by Abhinav & Charan —
            because every family deserves a beautiful celebration.
          </p>
        </div>

        <div className="footer-col">
          <h4>Events</h4>
          <ul>
            <li><a href="#events">Weddings</a></li>
            <li><a href="#events">Engagements</a></li>
            <li><a href="#events">Birthdays</a></li>
            <li><a href="#events">Corporate Events</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Connect</h4>
          <ul>
            <li><a href="https://www.instagram.com/archandcrownevents?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==">Instagram</a></li>
<li>
  <a 
    href="https://wa.me/917702254457?text=Hello%20Arch%20%26%20Crown!%20I%20am%20interested%20in%20planning%20an%20event." 
    target="_blank"
  >
    WhatsApp
  </a>
</li>            {/* <li><a href="#">Facebook</a></li> */}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copy">
          © 2025 Arch & Crown Events. All rights reserved.
        </div>
        <div className="footer-founders">
          Founded by <span>Abhinav & Charan</span>
        </div>
      </div>
    </footer>
  );
}